import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useContext } from 'react';
import { Box, Button, Flex, Grid, GridItem } from '@chakra-ui/react';
import { hasValue, useT } from '@progress-fe/core';
import { InputNumber, Select } from '../../inputs';
import { JsFieldInspector, JsFieldName } from '../../jsFormBase';
import { JsFormConfigContext } from '../../../contexts';
import { useJsFieldFormData } from '../../../hooks';
/**
 * Component renders "/schemas/jsf-group-composition-cracking" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is an instance of TGroupCompositionCrackingFormData.
 */
const GroupCompositionCrackingJsFieldFC = (props) => {
    const { t } = useT();
    const context = useContext(JsFormConfigContext) ?? {};
    const { runCallback, isInspector } = context;
    const { fieldConfig, fieldValues, onChangeFieldValues, onChangeFieldConfig } = useJsFieldFormData({
        config: props.formData?.fieldConfig ?? null,
        values: props.formData?.fieldValues ?? null,
        onChange: props.onChange
    });
    const handleChangeFormOptionValue = (option) => {
        if (!fieldValues) {
            return;
        }
        onChangeFieldValues({
            ...fieldValues,
            optionValue: option.value
        });
    };
    const handleChangeValue = (updated, value) => {
        if (!fieldValues) {
            return;
        }
        const newItems = fieldValues.items.map((item) => item.uuid === updated.uuid ? { ...updated, value } : item);
        onChangeFieldValues({
            ...fieldValues,
            items: newItems
        });
    };
    const handleNormalizeCallback = async () => {
        const callbackCode = fieldConfig?.normalization.callbackCode ?? '';
        if (!callbackCode) {
            return;
        }
        const formDataResult = await runCallback?.(callbackCode);
        if (hasValue(formDataResult)) {
            onChangeFieldConfig(formDataResult.fieldConfig);
            onChangeFieldValues(formDataResult.fieldValues);
        }
    };
    return (_jsx(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['object'], children: _jsx(Box, { "data-testid": "GroupCompositionCrackingJsField-test", "data-name": props.name, children: _jsxs(Flex, { p: "4px 0", flexDirection: "column", gap: "8px", children: [_jsxs(Grid, { gridTemplateColumns: `minmax(0, 180px) 1fr`, alignItems: 'center', children: [_jsx(JsFieldName, { name: fieldConfig?.title }), _jsx(Select, { name: props.name, options: fieldConfig?.options || [], isDisabled: props.schema.readOnly, placeholder: t('common.notSelected'), value: fieldConfig?.options.find((opt) => opt.value === fieldValues?.optionValue), onChange: (newValue) => {
                                    handleChangeFormOptionValue(newValue);
                                } })] }), _jsxs(Grid, { gap: "4px", p: "0 0 4px 0", alignItems: "center", borderBottom: "1px solid", borderColor: "border", templateColumns: "176px 1fr", children: [_jsx(GridItem, { children: t('common.component') }), _jsx(GridItem, { children: t('common.quantity') })] }), _jsx(Box, { p: "2px 0", children: fieldValues?.items.map((item) => (_jsxs(Grid, { gap: "4px", p: "2px 0", templateColumns: "176px 1fr", children: [_jsx(Flex, { align: "center", children: item.name }), _jsx(InputNumber, { isFloat: true, min: 0, size: "xs", variant: "outline", sx: { width: '100%' }, isOnChangeOnlyOnBlur: true, disabled: props.schema.readOnly, value: item.value || undefined, onChange: (value) => handleChangeValue(item, value || '') })] }, item.uuid))) }), !props.schema.readOnly && fieldConfig?.normalization.possible && (_jsx(Button, { size: "xs", variant: "ghost", onClick: handleNormalizeCallback, children: t('actions.normalize') }))] }) }) }));
};
export const GroupCompositionCrackingJsField = memo(GroupCompositionCrackingJsFieldFC);
//# sourceMappingURL=GroupCompositionCrackingJsField.js.map